import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Icon, { Icons } from '../../components/Icon/Icon';
import ListItem from '../../components/ListItem';
import PageHeader from '../../components/PageHeader';
import AppConfig from '../../config';
import { LOCALES_INFO, t } from '../../lang';
import HelperService from '../../services/HelperService';
import './AllWalletsPage.scss';

const { routes } = AppConfig;

const AllWalletsPage = () => {
	const navigate = useNavigate();
	const availableCurrencies = useSelector(store => store.app.availableCurrencies);
	const isInTelegram = useSelector(store => store.app.isInTelegram);
	const devices = useSelector(store => store.app.devices);
	const activeLang = useSelector(state => state.localization.lang);

	const goToLanguages = () => {
		navigate({ pathname: routes.languages });
	};

	const goToDevices = () => {
		navigate({ pathname: routes.devices });
	};

	const walletBalance = availableCurrencies.reduce((acc, currency) => acc + currency.AmountUsd, 0);
	const currentLanguageTitle = LOCALES_INFO[activeLang]?.title || 'English';

	const tetsWallets = [
		{
			Name: 'Wallet',
			Amount: walletBalance,
			Url: routes.mainPage,
		},
		// {
		// 	Name: 'Wallet 2',
		// 	Amount: 170.137,
		// },
		// {
		// 	Name: 'Wallet 3',
		// 	Amount: 16.5,
		// },
	];

	return (
		<div className='AllWalletsPage'>
			<div>
				<PageHeader header={'All wallets'} />
				<div className='AllWalletsPage-content'>
					{tetsWallets.map((i, index) => (
						<div key='index' onClick={() => navigate(i.Url)} className='AllWalletsPage-wallet'>
							<div className='title'>{i.Name}</div>
							<div className='balance'>$ {HelperService.FormatFiatWithoutCurrency(i.Amount)}</div>
						</div>
					))}
				</div>
			</div>
			<div className='AllWalletsPage-button-content'>
				<div className='AllWalletsPage-buttons-item'>
					{!isInTelegram && (
						<ListItem
							className={'AllWalletsPage-buttons-item-button'}
							icon={<Icon type={Icons.LANGUAGE_ICON} width={32} height={32} />}
							title={t('Language')}
							bottomSeparator
							rightTitle={
								<div className='AllWalletsPage-devices-right'>
									<span className='AllWalletsPage-devices-count'>{t(currentLanguageTitle)}</span>
									<Icon className='AllWalletsPage-devices-arrow' type={Icons.ARROW_CHEVRON} />
								</div>
							}
							onSelect={() => goToLanguages()}
						/>
					)}

					<ListItem
						className={'AllWalletsPage-buttons-item-button'}
						icon={<Icon type={Icons.DEVICES} width={32} height={32} />}
						title={t('Devices')}
						rightTitle={
							<div className='AllWalletsPage-devices-right'>
								<span className='AllWalletsPage-devices-count'>{devices.length}</span>
								<Icon className='AllWalletsPage-devices-arrow' type={Icons.ARROW_CHEVRON} />
							</div>
						}
						onSelect={() => goToDevices()}
					/>
				</div>
			</div>
		</div>
	);
};

export default AllWalletsPage;
